import { StudyMetadata } from './StudyMetadata';
import { OHIFSeriesMetadata } from './OHIFSeriesMetadata';

export class OHIFStudyMetadata extends StudyMetadata {
  /**
   * @param {Object} Study object.
   */
  constructor(data, uid) {
    super(data, uid);
    this.init();
  }

  init() {
    const study = this.getData();
    // study.series = this.obj3(study.series);
    // study.series.map((item, index) => {
    //   if (!item.SeriesNumber) {
    //     item.SeriesNumber = index + 1;
    //   }
    // })

    // define "_studyInstanceUID" protected property
    Object.defineProperty(this, '_studyInstanceUID', {
      configurable: false,
      enumerable: false,
      writable: false,
      value: study.StudyInstanceUID,
    });

    // populate internal list of series
    study.series.forEach(series => {
      this.addSeries(new OHIFSeriesMetadata(series, study));
    });
  }
  deteleObject(obj) {
    var uniques = [];
    var stringify = {};
    for (var i = 0; i < obj.length; i++) {
      var keys = Object.keys(obj[i]);
      keys.sort(function (a, b) {
        return (Number(a) - Number(b));
      });
      var str = '';
      for (var j = 0; j < keys.length; j++) {
        str += JSON.stringify(keys[j]);
        str += JSON.stringify(obj[i][keys[j]]);
      }
      if (!stringify.hasOwnProperty(str)) {
        uniques.push(obj[i]);
        stringify[str] = true;
      }
    }
    uniques = uniques;
    return uniques;
  }
  obj2(arr) {
    let arr1 = [];
    let newArr = [];
    for (let i in arr) {
      if (arr1.indexOf(arr[i].SeriesInstanceUID) == -1) {
        arr1.push(arr[i].SeriesInstanceUID);
        newArr.push(arr[i])
      }
    }
    return newArr;

  }
  obj3(arr) {
    let arr1 = [];
    let newArr = [];
    for (let i in arr) {
      if (arr[i].SeriesInstanceUID == '1.2.826.0.1.3680043.8.1055.1.20111103111157341.71737845.59538788') {
        arr1.push(arr[i].SeriesInstanceUID);
        newArr.push(arr[i])
      }
      if (arr[i].SeriesInstanceUID == '1.2.826.0.1.3680043.8.1055.1.20111103111204584.92619625.78204558') {
        arr1.push(arr[i].SeriesInstanceUID);
        newArr.push(arr[i])
      }
    }
    return newArr;

  }
}
